var map = {
	"./Cindy_Cooper.jpg": 4575,
	"./Graham_Wheeler.jpg": 2708,
	"./Laura_Flight.jpg": 6701,
	"./Mike_Bradburn.jpg": 5034,
	"./Munya_Dimairo.jpg": 7997,
	"./NIHR_logo.svg": 8713,
	"./Philip_Pallmann.jpg": 3619,
	"./Thomas_Jaki.jpg": 6303,
	"./cambridge_logo_2.png": 3444,
	"./cardiff_ctr.jpg": 1680,
	"./lancaster_uni.svg": 3918,
	"./panda-letter-logo.png": 5648,
	"./panda-logo.png": 1775,
	"./plasma.jpg": 8453,
	"./purple_coral.jpg": 4243,
	"./sheffield_ctru.png": 506,
	"./ucl_ctc.jpg": 2994,
	"./uos-crest.svg": 5645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;